import HeaderSearch from '../../scaffold/src/components/HeaderSearch';
import NoticeIcon from '../../scaffold/src/components/NoticeIcon';
import PageHeader from '../../scaffold/src/components/PageHeader';
import Exception from '../../scaffold/src/components/Exception';
import GlobalFooter from '../../scaffold/src/components/GlobalFooter';
import Result from '../../scaffold/src/components/Result';
import DescriptionList from '../../scaffold/src/components/DescriptionList';

export default {
  HeaderSearch,
  NoticeIcon,
  PageHeader,
  Exception,
  GlobalFooter,
  Result,
  DescriptionList,
};



// WEBPACK FOOTER //
// ./index.js